import { AnalogInput, AnalogOutput, AnalogTemperatureSensor, Buzzer, GuardIndicator, IOExtension, OutputAction, Pump, RelayControl, ThreewayTap, } from 'z3k-config';
import { inputValues2PinIds, outputValues2PinIds } from 'z3k-parser/validation/z3k/pins';
import { getRadioRelays } from 'z3k-parser/lib/sensors/radio';
export function getAllInputs(z3k_config, need_smoke) {
    return [
        ...AnalogInput.get
            .where(z3k_config, (item) => 
        //в действиях с выходом можно использовать выход, назначенный на датчик дыма,
        // поэтому исключаем его из проверки
        need_smoke ? true : item.sensor_type !== AnalogInput.Type.SMOKE)
            .map((item) => ({
            num: item.physical_input_num,
            name: item.name,
            obj_type: 'analog_inputs',
        })),
        ...AnalogTemperatureSensor.get.all(z3k_config).map((item) => ({
            num: item.physical_input_num,
            name: item.name,
            obj_type: 'analog_temperature_sensors',
        })),
    ].filter(({ num }) => num !== -1);
}
export function getManagedMechanismOutputs(z3k_config) {
    return [
        ...Buzzer.get.all(z3k_config).map((item) => ({
            num: item.physical_output,
            name: item.name,
            obj_type: 'buzzers',
        })),
        ...GuardIndicator.get.all(z3k_config).map((item) => ({
            num: item.physical_output,
            name: item.name,
            obj_type: 'guard_indicators',
        })),
        ...Pump.get.all(z3k_config).map((item) => ({
            num: item.physical_output,
            name: item.name,
            obj_type: 'pumps',
            is_inverse: Pump.isInverse(item),
        })),
        ...RelayControl.get.all(z3k_config).map((item) => ({
            num: item.physical_output,
            name: item.name,
            obj_type: 'relay_controls',
            is_inverse: RelayControl.isInverse(item),
        })),
        ...ThreewayTap.get.all(z3k_config).map((item) => ({
            num: item.physical_output1,
            name: item.name,
            obj_type: 'threeway_taps',
            is_inverse: true, //закрытие
        })),
        ...ThreewayTap.get.all(z3k_config).map((item) => ({
            num: item.physical_output2,
            name: item.name,
            obj_type: 'threeway_taps',
        })),
    ].filter(({ num }) => num !== -1);
}
export function getAllOutputs(z3k_config) {
    return [
        ...getManagedMechanismOutputs(z3k_config),
        ...AnalogOutput.get.all(z3k_config).map((item) => ({
            num: item.physical_output,
            name: item.name,
            obj_type: 'analog_outputs',
        })),
        ...OutputAction.get.all(z3k_config).map((item) => ({
            num: item.physical_output,
            name: item.name,
            obj_type: 'output_actions',
        })),
    ].filter(({ num }) => num !== -1);
}
export function getAllUsedIO(config, device_spec) {
    const io_extensions = IOExtension.get.all(config);
    const radio_relays = getRadioRelays(config);
    const busy_input_pins = inputValues2PinIds(device_spec, getAllInputs(config, true), io_extensions, radio_relays, false);
    const busy_output_pins = outputValues2PinIds(device_spec, getAllOutputs(config), io_extensions, radio_relays);
    return {
        busy_input_pins,
        busy_output_pins,
    };
}
